export const Props = () => ({
    //--------------------------------------------------------------------------
    //                                Имя поля
    //--------------------------------------------------------------------------
    name: {
        type: String,
        required: false,
    },
    //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

    //--------------------------------------------------------------------------
    //                                Label поля
    //--------------------------------------------------------------------------
    label: {
        type: String,
        required: false,
    },
    //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

    //--------------------------------------------------------------------------
    //                      Дополнительный текст для поля
    //--------------------------------------------------------------------------
    option: {
        type: String,
        required: false,
    },
    //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

    //--------------------------------------------------------------------------
    //                                Placeholder
    //--------------------------------------------------------------------------
    placeholder: {
        type: String,
        required: false,
    },
    //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxх

    //--------------------------------------------------------------------------
    //                                 Есть ли ошибка
    //--------------------------------------------------------------------------
    isError: {
        type: Boolean,
        required: false,
        default: false,
    },
    //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxх

    //--------------------------------------------------------------------------
    //                                Текст ошибки
    //--------------------------------------------------------------------------
    errorMessage: {
        type: String,
        required: false,
        default: '',
    },
    //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

    //--------------------------------------------------------------------------
    //        Значение для передачи значения в родитель формы, для валидации
    //--------------------------------------------------------------------------
    modelValue: {
        type: String,
        required: false,
        default: '',
    },
    //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

});
